// extracted by mini-css-extract-plugin
export default {"capturePhoto":"styles_capturePhoto__rbDyy","camera":"styles_camera__-Rn8V","btnBox":"styles_btnBox__sbcXC"};